import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const faqs = [
  {
    q: "What does Tek mean?",
    a: "A tek screw is a self-drilling, self-tapping screw. It cuts its own hole through steel as it drives, so you do not pre-drill and tap every point. That screw is what makes this system work without a welder, and it is what the company is named after. The screws come in the package with the bracket.",
  },
  {
    q: "Do I need to pre-drill?",
    a: "Usually not. The self-drilling point is designed to start and cut on its own. On heavier wall post material, or when you want the screw to start exactly on a mark, a pilot hole helps.",
  },
  {
    q: "Will this work on round posts?",
    a: "Yes. Round or square tubing, both are called out in the install instructions. The cluster of holes in the center of the bracket gives you fastening points to work with as a round face curves away from the plate.",
  },
  {
    q: "How many brackets do I need?",
    a: "One bracket per rail connection per post. A two-rail fence needs two at each post, a three-rail fence needs three. Corners, gate posts and ends change the count, so walk your line and count connections rather than posts.",
  },
  {
    q: "What size rail fits?",
    a: "It is built for square tubing, rectangular tubing, or cee purlin. The rail slips over the bracket's 1 inch end tabs, so the fit depends on your rail's inside dimension. Call and confirm the section you plan to run. The 4 3/16 inch figure in the specs is the span between the two tabs, not a maximum rail size.",
  },
  {
    q: "Can I take it back apart?",
    a: "Screws come out. A welded joint does not. If you set a rail wrong or need to pull a section, you back the screws out and reset it.",
  },
];

export const FAQ = () => (
  <section className="section" id="faq" data-testid="faq-section">
    <div className="wrap">
      <SectionHead num="08" eyebrow="FAQ" title="Before you order." />
      <Reveal>
        <div className="faq-wrap">
          <Accordion type="single" collapsible>
            {faqs.map((f, i) => (
              <AccordionItem value={`faq-${i}`} key={f.q} style={{ borderColor: "var(--line)" }}>
                <AccordionTrigger className="faq-q" data-testid={`faq-trigger-${i + 1}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="faq-a" data-testid={`faq-content-${i + 1}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Reveal>
    </div>
  </section>
);
